import { render, staticRenderFns } from "./EditOderServicioColumn.vue?vue&type=template&id=5afbee74&scoped=true&"
import script from "./EditOderServicioColumn.vue?vue&type=script&lang=ts&"
export * from "./EditOderServicioColumn.vue?vue&type=script&lang=ts&"
import style0 from "./EditOderServicioColumn.vue?vue&type=style&index=0&id=5afbee74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afbee74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5afbee74', component.options)
    } else {
      api.reload('5afbee74', component.options)
    }
    module.hot.accept("./EditOderServicioColumn.vue?vue&type=template&id=5afbee74&scoped=true&", function () {
      api.rerender('5afbee74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/OrdenesServicio/components/EditOderServicioColumn.vue"
export default component.exports